import { useRef } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

const ErrorMediaLibraryPostModal = ({
    isOpen,
    toggle,
    mediaLibraryError,
    callback,
    isLoadingCallback
}) => {
    const { t } = useTranslation('scheduler');
    const initRef = useRef(null);

    return (
        <Modal open={isOpen} onDismiss={toggle} initialFocus={initRef}>
            <Modal.Body>
                <Modal.Title> {t('media_library.error_creating_post')}</Modal.Title>
                <Modal.Content className="pt-m text-center font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {t(mediaLibraryError ?? 'media_library.error_creating_post_content')}
                </Modal.Content>
                <Modal.Footer
                    className="flex flex-col items-center justify-between space-y-3 pb-12 pt-8 xs:flex-row xs:space-x-3 xs:space-y-0"
                    divider={false}>
                    <Button variant="secondary" className="w-full" onClick={toggle}>
                        {t('commons:cancel')}
                    </Button>
                    <Button onClick={callback} isLoading={isLoadingCallback} className="w-full">
                        {t('commons:try_again')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

export default ErrorMediaLibraryPostModal;
